import * as tslib_1 from "tslib";
import { isPlatformBrowser } from '@angular/common';
import { cache } from '../cache';
var OSService = /** @class */ (function () {
    function OSService(platformId) {
        this.platformId = platformId;
    }
    Object.defineProperty(OSService.prototype, "os", {
        get: function () {
            var isBrowser = isPlatformBrowser(this.platformId);
            var macTests = ['Mac', 'iPhone', 'iPad', 'iPod'];
            if (isBrowser && macTests.find(function (test) { return window.navigator.platform.includes(test); })) {
                return 'mac';
            }
            else {
                return 'win';
            }
        },
        enumerable: true,
        configurable: true
    });
    tslib_1.__decorate([
        cache(),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], OSService.prototype, "os", null);
    return OSService;
}());
export { OSService };
